import React from "react";
import congratsImage from "../../../assets/img/brand/submit_assessment.png";
import { Button, Col, Row } from "reactstrap";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";
function ReportStatus({ downloadReportHandler }) {
  const navigate = useNavigate();
  return (
    <div className="w-100 justify-content-center flex-column align-items-center">
      <div className="mx-auto text-center">
        <div>
          <img src={congratsImage} alt="congratulations" />
        </div>

        <h3
          style={{
            fontSize: "32px",
            fontWeight: "600",
            color: "#1273EB",
            marginTop: "20px",
            marginBottom: "10px"
          }}
        >
          Congratulations!
        </h3>
        <p
          className="mx-auto"
          style={{
            fontSize: "18px",
            fontWeight: "600",
            color: "#283046",
            marginBottom: "20px",
            maxWidth: "600px",
            textAlign: "center"
          }}
        >
          Thank you for completing the Growth Plan assessment. Your report is now ready. Click below
          to download it.
        </p>

        <Button
          className="px-5 py-2 border-0 shadow-none d-flex align-items-center mx-auto"
          onClick={downloadReportHandler}
          type="button"
          style={{
            backgroundColor: "#FF9F43",
            color: "white",
            gap: "10px",
            fontSize: "16px",
            fontWeight: "700"
          }}
        >
          <Icon icon="icon-park-outline:download-two" width="24" height="24" color="#fff" />
          <span>Download Report</span>
        </Button>
        <Button
          outline
          className="btn btn-outline-secondary mt-3"
          style={{
            fontSize: "16px",
            fontWeight: "700",
            width: "280px"
          }}
          onClick={() => navigate(-1)}
        >
          Back to Assessment
        </Button>
      </div>
    </div>
  );
}

export default ReportStatus;
